const $$splitNotFoundComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/route.tsx?tsr-split=notFoundComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { HTTPError } from 'ky';
import { z } from 'zod';
import { getViewQueryOptions } from '@/lib/queries/view/useView';
import { saveLastVisitedView } from '@/lib/utils/roadmapping/lastVisited';
import { itemFilterSearchSchema } from '@/lib/zod-schemas/itemFilterSearchSchema';
const paramsSchema = z.object({
  roadmapId: z.coerce.number().int().positive(),
  viewId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId/view/$viewId')({
  validateSearch: zodValidator(itemFilterSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  params: paramsSchema,
  notFoundComponent: lazyRouteComponent($$splitNotFoundComponentImporter, 'notFoundComponent'),
  loader: async ({
    params: {
      viewId,
      roadmapId
    },
    context: {
      queryClient
    }
  }) => {
    try {
      await queryClient.ensureQueryData(getViewQueryOptions(viewId));
      saveLastVisitedView(roadmapId, viewId);
    } catch (error) {
      if (error instanceof HTTPError && error?.response?.status === 404) {
        throw notFound();
      }
      throw error;
    }
  }
});